





















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteGrupoRepassesRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteGrupoRepassesRemuneracaoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ViewSuporteGrupoRepasses extends Vue {
  $refs!: { formGrupoRepasse: any }

  contratosHeaders = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  modalGrupoRepasse: boolean = false
  modoModal: 'CREATE' | 'EDIT' = 'CREATE'
  loadingSalvar: boolean = false
  loadingTabela: boolean = false
  formGrupoRepasseValido: boolean = true
  paginaAtual: number = 1
  itensPorPagina: number = 10
  visibleResults: number = 5

  itemGrupoRepasse: any = {
    id: '',
    nome: '',
  }

  rulesGrupoRepasse: any = {
    nome: [v => !!v || 'O nome é obrigatório'],
  }

  get getBackofficeContratosStore() {
    return getModule(SuporteGrupoRepassesRemuneracaoStore, this.$store)
  }

  get grupoRepasses() {
    return this.getBackofficeContratosStore.gruposRepasses
  }

  get itemsLength() {
    return Math.ceil(this.grupoRepasses.length / this.itensPorPagina) || 1
  }

  get grupoRepassesPaginados() {
    const start = (this.paginaAtual - 1) * this.itensPorPagina
    const end = start + this.itensPorPagina
    return this.grupoRepasses.slice(start, end)
  }

  async init() {
    this.loadingTabela = true
    this.paginaAtual = 1
    await this.getBackofficeContratosStore.getGruposRepasses()
    this.loadingTabela = false
  }

  abrirModalCriar() {
    this.modoModal = 'CREATE'
    this.itemGrupoRepasse = { id: '', nome: '' }
    this.modalGrupoRepasse = true
  }

  abrirModalEditar(item: any) {
    this.modoModal = 'EDIT'
    this.$forceUpdate()
    this.itemGrupoRepasse = { ...item }
    this.modalGrupoRepasse = true
  }

  fecharModal() {
    this.modalGrupoRepasse = false
    this.itemGrupoRepasse = { id: '', nome: '' }
    // this.$refs.formGrupoRepasse.resetValidation()
  }

  async salvarGrupoRepasse() {
    if (!this.$refs.formGrupoRepasse.validate()) {
      return
    }

    this.loadingSalvar = true

    try {
      const request = await this.getBackofficeContratosStore.criarAtualizarGrupoRepasse(this.itemGrupoRepasse)

      if (request.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Grupo de repasse ${this.modoModal === 'CREATE' ? 'criado' : 'atualizado'} com sucesso!`,
          icon: 'done',
          color: '#2E7D32',
        })
        await this.init()
        this.fecharModal()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message || `Erro ao ${this.modoModal === 'CREATE' ? 'criar' : 'atualizar'} grupo de repasse.`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao processar a requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.loadingSalvar = false
    }
  }

  async created() {
    await this.init()
  }
}
